/**
 * Password Setup API
 * 비밀번호 설정 관련 API 호출 함수
 */

import { apiClient } from '../../../core/api/client';
import { PasswordSetupRequest, PasswordSetupResponse } from '../types/passwordSetup';

const BASE_PATH = '/api/v1/mob/login';

/**
 * 비밀번호 설정 API
 * POST /api/v1/mob/login/password-setup
 * @param params 비밀번호 설정 요청 파라미터 (userId, password, confirmPassword)
 * @returns 비밀번호 설정 응답
 */
export const setupPassword = async (params: PasswordSetupRequest): Promise<PasswordSetupResponse> => {
    const response = await apiClient.post<PasswordSetupResponse>(
        `${BASE_PATH}/password-setup`,
        params  // body로 전송
    );
    return response.data;
};
